export const font = {
  fontFamily: "'Montserrat', sans-serif",
};

export const colors = {
  greyColor: '#6F6F70',
  purpleColor: '#3f51b5',
};
